import { Suspense, forwardRef } from 'react';
import { LingodaLogo } from '@lingoda/logotype';
import { type RouteConfigExtended, RouterLink, studentHomePath } from '@lingoda/router';
import { Box, Toolbar, useResolution } from '@lingoda/ui';
import { BaseAppBar } from '../NavigationBars/components';
import { Notifications } from '../Notifications';
import { HeaderDrawer } from '../HeaderDrawer';
import { BookClassMobileCTA } from '../BookClassMobileCTA';
import { SidebarNavigation } from '../NavigationBars/SidebarNavigation';
import HeaderTabs from './HeaderTabs';

interface Props {
    routes: RouteConfigExtended[];
}

export const StudentHeader = forwardRef<HTMLDivElement, Props>(({ routes }, ref) => {
    const isPhablet = useResolution('phablet');

    return (
        <BaseAppBar ref={ref}>
            <Toolbar>
                {isPhablet ? (
                    <Box gap={1.5} display={'flex'} flexGrow={1} justifyContent={'flex-end'}>
                        <Suspense fallback={null}>
                            <BookClassMobileCTA />
                        </Suspense>
                        <Notifications />
                        <HeaderDrawer>
                            {(handleClose) => <SidebarNavigation onClose={handleClose} />}
                        </HeaderDrawer>
                    </Box>
                ) : (
                    <>
                        <RouterLink to={studentHomePath(undefined)}>
                            <Box mr={{ xs: 3, sm: 2, md: 3 }}>
                                <LingodaLogo isIcon />
                            </Box>
                        </RouterLink>
                        <HeaderTabs routes={routes} />
                    </>
                )}
            </Toolbar>
        </BaseAppBar>
    );
});

StudentHeader.displayName = 'StudentHeader';
